const PriorityRange: { [key: string]: string } = Object.freeze({
  Grave: 'g',
  'Média-Alta': 'ma',
  Media: 'm',
  'Média-Baixa': 'mb',
  Leve: 'l',
});

export default PriorityRange;
